import {creates, hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {chart} from '@xh/hoist/cmp/chart';
import {RatesWidgetModel} from './RatesWidgetModel';

export const ratesWidget = hoistCmp.factory({
    model: creates(() => RatesWidgetModel),
    render({model}) {
        return panel({
            item: chart()
        });
    }
});
